export default "__VITE_ASSET__D48oBTkx__"